import { QuotePremiums } from '../hooks/premiums'
import { CustomerAccount } from './types'

export const isCheckoutSkippable = (
  customerAccount: CustomerAccount,
  { totals }: QuotePremiums,
) => !customerAccount.paymentMethodType && totals.discounted <= 0.001
